var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoSpecimanFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11623_44881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0C41.3137 0 44 2.68629 44 6V17.1553C43.9119 17.1471 43.8227 17.1426 43.7324 17.1426C42.1545 17.1426 40.875 18.422 40.875 20C40.875 21.578 42.1545 22.8574 43.7324 22.8574C43.8227 22.8574 43.9119 22.8519 44 22.8438V34C44 37.3137 41.3137 40 38 40H10C6.68629 40 4 37.3137 4 34V6C4 2.68629 6.68629 1.28851e-07 10 0H38Z",
    fill: "#04B7B1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9522 30.4769C13.9717 30.4769 13.0944 31.0217 12.6586 31.8933L12.0622 33.086C11.9705 33.2637 11.9819 33.4759 12.0851 33.6479C12.1884 33.8142 12.3719 33.9174 12.5726 33.9174H34.3623C34.6777 33.9174 34.9357 33.6594 34.9357 33.344C34.9357 31.7843 34.7809 30.2189 34.477 28.6879L34.2706 27.6672C34.1444 27.0422 33.852 26.4802 33.4391 25.9986C33.6685 25.2245 33.7889 24.4217 33.7889 23.596C33.7889 19.8114 31.2716 16.4684 27.705 15.3789L29.236 12.3628C29.3048 12.2309 29.3163 12.0703 29.2704 11.927C29.2245 11.7836 29.1213 11.6632 28.9837 11.5944L28.4734 11.3363L30.033 8.26858C30.1764 7.9876 30.0617 7.64355 29.7807 7.5002L27.7336 6.46232C27.596 6.39351 27.4412 6.38204 27.2979 6.42791C27.1545 6.47379 27.0341 6.577 26.9653 6.71462L25.4056 9.78239L24.8952 9.51862C24.6143 9.37527 24.2702 9.48995 24.1269 9.77092L18.7941 20.253C18.7253 20.3848 18.7138 20.5454 18.7597 20.6887C18.8056 20.8321 18.9088 20.9525 19.0464 21.0213L19.5567 21.2794L18.5131 23.3265C18.3698 23.6074 18.4845 23.9572 18.7654 24.1006L20.8125 25.1384C20.8928 25.1786 20.9846 25.2015 21.0706 25.2015C21.1336 25.2015 21.191 25.1901 21.2483 25.1729C21.3917 25.127 21.5121 25.0238 21.5809 24.8861L22.6245 22.8391L23.1349 23.1028C23.2151 23.143 23.3069 23.1659 23.3929 23.1659C23.5993 23.1659 23.8 23.0512 23.9032 22.8505L26.1051 18.5212C28.5479 18.957 30.3484 21.0729 30.3484 23.596C30.3484 23.9974 30.3025 24.393 30.2108 24.7772C30.1936 24.7772 30.1764 24.7829 30.1535 24.7887C30.0904 24.7944 30.0273 24.8116 29.9585 24.8288C29.8553 24.846 29.7578 24.8689 29.6546 24.8976C29.5915 24.9206 29.5227 24.9435 29.4596 24.9664C29.3679 25.0008 29.2761 25.0352 29.1844 25.0811C29.1213 25.1098 29.0582 25.1384 28.9952 25.1729C28.9091 25.2187 28.8231 25.2703 28.7429 25.3219C28.6798 25.3621 28.6224 25.3965 28.5651 25.4424C28.4848 25.4997 28.4103 25.5628 28.3357 25.6259C28.2841 25.6717 28.2325 25.7176 28.1809 25.7635C28.1064 25.8323 28.0376 25.9126 27.9687 25.9871C27.9286 26.0387 27.8827 26.0846 27.8426 26.1419C27.7738 26.2279 27.7107 26.3254 27.6476 26.4172C27.619 26.4688 27.5846 26.5146 27.5559 26.5605C27.4699 26.7096 27.3896 26.8644 27.3265 27.0307L26.7646 28.4356L25.6063 27.5927L25.7267 27.6041C25.7439 27.6099 25.7668 27.6099 25.784 27.6099C26.0765 27.6099 26.323 27.392 26.3517 27.0938C26.3861 26.7841 26.1568 26.4974 25.8414 26.4688L14.9236 25.3219C14.6082 25.2875 14.3272 25.5169 14.2985 25.8323C14.2641 26.1419 14.4935 26.4286 14.8089 26.4573L23.4961 27.3748C23.5362 27.4665 23.5936 27.5468 23.6796 27.6099L26.323 29.5308L25.9446 30.4769H14.9522Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11623_44881",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11623_44881"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11623_44881",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoSpecimanFill);
export default __webpack_public_path__ + "static/media/HistoSpecimanFill.2cb665b1cd7c02f9269b5aeadf0a0825.svg";
export { ForwardRef as ReactComponent };